import { z } from "zod";
import { PreReviewDocumentSchema } from "../treezor/index.js";

export default {
  params: z.object({
    accountId: z.string(),
  }),
  response: z.array(PreReviewDocumentSchema),
};
